"use client";

import React from "react";
import { MapPin, Clock, Info, Phone, Mail, Calendar } from "lucide-react";
import { Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from "@/components/ui/table";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function LocalizacaoEHorarios() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const address = "Avenida Ásia, 444\xA0 lote 3 Quadra C loja 3 - Galeria Alpha Business - Alphaville - Rio das Ostras, RJ, CEP 28890-001";
  const phone = "(22) 999144228";
  const email = "contato@dilsaudecapilar.com.br";
  const mapUrl = "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3657.1975860215!2d-46.6520!3d-23.5629!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjPCsDMzJzQ2LjQiUyA0NsKwMzknMDcuMiJX!5e0!3m2!1spt-BR!2sbr!4v1620000000000!5m2!1spt-BR!2sbr";
  const hoursData = [{
    day: "Segunda-feira",
    hours: "09:00 - 18:00"
  }, {
    day: "Terça-feira",
    hours: "09:00 - 18:00"
  }, {
    day: "Quarta-feira",
    hours: "09:00 - 18:00"
  }, {
    day: "Quinta-feira",
    hours: "09:00 - 18:00"
  }, {
    day: "Sexta-feira",
    hours: "09:00 - 18:00"
  }, {
    day: "Sábado",
    hours: "Sob agendamento"
  }, {
    day: "Domingo",
    hours: "Fechado"
  }];
  const instructions = ["Por favor, compareça com o cabelo lavado 24h antes da consulta.", "Evite o uso de cremes, óleos ou finalizadores no couro cabeludo no dia da avaliação.", "Traga exames de sangue recentes (últimos 6 meses), caso possua.", "Chegue com 10 minutos de antecedência para preenchimento de ficha."];
  return;
}